export default Object.freeze({
  doCreate        : 'doCreate',
  doJoin          : 'doJoin',
  didJoin         : 'didJoin',
  didLeave        : 'didLeave',
  doSetUserName   : 'doSetUserName',
  didSetUserName  : 'didSetUserName',
  doSetBoardName  : 'doSetBoardName',
  didSetBoardName : 'didSetBoardName',
});
